import { useCallback } from 'react';

import utils from './utils';
import BaseModal from './BaseModal';

/**
 * Base - URL-based dialog wrapper
 * 
 * Uses BaseModal for the UI, but manages dialog state via URL params.
 * Used by campaigns/activities dialogs.
 * 
 * @param {string} title - Modal title
 * @param {function} close - Additional callback when modal is closed
 * @param {React.ReactNode} children - Modal content
 */
const Base = ({ title, close, children }) => {

  const { setDialog } = utils.useDialog();

  const _close = useCallback(() => {
    setDialog(null);
    if (close) {
      close();
    }
  }, [setDialog, close]);

  return (
    <BaseModal title={title} onClose={_close}>
      {children}
    </BaseModal>
  );
};

export default Base;
